import { render, staticRenderFns } from "./FooterStyle4.vue?vue&type=template&id=44393c28&scoped=true"
import script from "./FooterStyle4.vue?vue&type=script&lang=js"
export * from "./FooterStyle4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44393c28",
  null
  
)

export default component.exports